import React from 'react';

import CountryInfo from '../CountryInfo';

const STIMULUS_SECTION = {
    title: 'Bank of China Monetary Stimulus',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">
                The stimulus includes:
            </p>
            <ul>
                <li>
                    Expanded reverse repo operations by injecting $174 billion
                    of liquidity into markets.
                </li>
                <li>
                    Lowering the one-year medium-term lending facility (MLF)
                    rate/loans to financial institutions by 10 basis points
                    (bps) to 3.15% from 3.25%
                </li>
                <li>
                    Lowered bank reserve requirements, freeing up about $79
                    billion to be lent out.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'China to inject US$174 billion of liquidity into markets amid new coronavirus outbreak',
            url: 'https://www.scmp.com/economy/china-economy/article/3048618/china-inject-us174-billion-liquidity-markets-amid-new',
        },
        {
            title: 'China’s central bank cuts rate for medium-term loans to support virus-hit economy',
            url: 'https://www.cnbc.com/2020/02/17/china-pboc-cuts-rate-for-medium-term-loans-to-support-virus-hit-economy.html',
        },
        {
            title: 'China pumps $79 billion into economy with bank cash reserve cut',
            url: 'https://www.reuters.com/article/us-china-economy-rrr-cut/china-pumps-79-billion-into-economy-with-bank-cash-reserve-cut-idUSKBN2101B3',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'China',
    lastUpdated: 'March 17, 2020',
    introSection: (
        <p>
            China has announced a stimulus package - People&apos;s Bank of China
            (PBOC) Monetary Stimulus.
        </p>
    ),
    sections: [STIMULUS_SECTION],
};

const ChinaInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default ChinaInfo;
